import classNames from 'classnames';
import React from 'react';

import NetworkLoader from '../../components/network-loader';

import styles from './root.scss';
import { Text } from '@wix/design-system';

interface Props {
  children: any;
}

const RootLayout = ({ children }: Props) => {
  return (
    <div className={classNames('ltr', styles.rootLayout)}>
      <NetworkLoader />
      <Text>{children}</Text>
    </div>
  );
};

export default RootLayout;
